import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=62b6bf0b&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=62b6bf0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6bf0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b6bf0b')) {
      api.createRecord('62b6bf0b', component.options)
    } else {
      api.reload('62b6bf0b', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=62b6bf0b&scoped=true&", function () {
      api.rerender('62b6bf0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PVv6PT5ZrRrJ/JS/comp/CookieBox.vue"
export default component.exports